


























































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import tournamentStore from '@/modules/tournament/tournament.store'
import { TournamentEntity, ResponseStatus } from '@/api/tournament'
import { StageAPI, StageEntity, StageState } from '@/api/stage'
import StageBracket from '@/modules/tournament/components/StageBracket'
import TournamentDetailsHeader from '@/modules/tournament/components/TournamentDetailsHeader'
import { getRealtimeConnection, realtimeEventTarget } from '@/utils/realtime'
import { HubConnection } from '@microsoft/signalr'
import { CancelError, CancellationToken } from '@/utils/cancel'

@Component({
  components: {
    StageBracket,
    TournamentDetailsHeader
  }
})
export default class TournamentDetailsBracket extends Vue {
  @Prop({ default: true }) displayHeader!: boolean
  @Prop({ default: false }) dense!: boolean
  tournamentModule = getModule(tournamentStore, this.$store)
  stageTab: number | null = 0
  groupTab: number | null = 0
  stages: StageEntity[] = []
  realtimeConnection!: HubConnection
  realtimeConnectionCancellationToken = new CancellationToken()
  isFetched: boolean = false
  isLoading: boolean = true
  loadTime: Date = new Date()

  interval: number | null = null

  /* Vuex State */
  get tournament(): TournamentEntity | null {
    return this.tournamentModule.selectedTournament
  }

  get tournamentId() {
    return this.tournament!.tournamentId
  }

  get StageState() {
    return StageState
  }

  get isMobileView() {
    return this.$vuetify.breakpoint.smAndDown
  }
  get mobileWidth() {
    return this.isMobileView ? 12 : undefined
  }

  @Watch('stageTab')
  onStageTabChanged() {
    this.groupTab = 0
  }

  /* Vue Hooks */
  async created() {
    await this.fetchStages()
    await this.subscribeRealtimeEvents()
    realtimeEventTarget.addEventListener(
      'connect',
      this.subscribeRealtimeEvents
    )
    realtimeEventTarget.addEventListener(
      'reconnected',
      this.subscribeRealtimeEvents
    )
    this.interval = window.setInterval(() => {
      this.$forceUpdate()
    }, 15 * 1000)
  }

  async beforeDestroy() {
    await this.unsubscribeRealtimeEvents()
    realtimeEventTarget.removeEventListener(
      'connect',
      this.subscribeRealtimeEvents
    )
    realtimeEventTarget.removeEventListener(
      'reconnected',
      this.subscribeRealtimeEvents
    )
    clearInterval(this.interval!)
  }

  /* Methods */
  async fetchStages() {
    this.isLoading = true
    try {
      const response = await StageAPI.getTournamentStages(this.tournamentId)
      if (response.data.status === ResponseStatus.Ok) {
        let data = []
        for (const [index, stage] of response.data.payload!.entries()) {
          const res = await StageAPI.getStage(stage.stageId)
          if (res.data.payload) {
            data.push(res.data.payload)
          }
        }
        this.stages = data
        this.loadTime = new Date()
      }
    } catch {
    } finally {
      this.isFetched = true
      this.isLoading = false
    }
  }

  async subscribeRealtimeEvents() {
    try {
      this.realtimeConnection = await getRealtimeConnection(
        this.realtimeConnectionCancellationToken
      )
    } catch (err) {
      if (err instanceof CancelError) {
        return
      }

      this.$toast.error(
        this.$t('TournamentDetailsBracket.FailConnectServerMessage')
      )
      console.error(err)
    }
    this.realtimeConnection.on(
      'stageBracketUpdated',
      this.onStageBracketUpdated
    )
  }

  async unsubscribeRealtimeEvents() {
    this.realtimeConnectionCancellationToken.cancel()
    if (this.realtimeConnection) {
      this.realtimeConnection.off(
        'stageBracketUpdated',
        this.onStageBracketUpdated
      )
    }
  }

  async onStageBracketUpdated() {
    await this.fetchStages()
    this.$toast(this.$t('TournamentDetailsBracket.BracketUpdated'), {
      color: 'green',
      x: 'center',
      y: 'bottom',
      icon: 'mdi-clock-check-outline',
      dismissable: true
    })
  }

  getIsDisplayStageBracket(stage: StageEntity) {
    if (stage.state === 'Initial' || !stage.isBracketVisible) return false
    return true
  }

  getStageBracketInvisibleMessage(stage: StageEntity) {
    if (stage.state === 'Initial')
      return this.$t('TournamentDetailsBracket.TheBracketIsNotReady')
    else if (!stage.isBracketVisible)
      return this.$t('TournamentDetailsBracket.AdminAdjustBracket')
    return ''
  }

  /* Getter */
  get hasStages() {
    return this.tournament && this.stages.length > 0
  }

  get hasBracket() {
    if (!this.hasStages) return false

    return this.stages.some(stage => stage.brackets && stage.brackets.length)
  }

  get groups() {
    if (!this.hasStages) return []

    const stage = this.stages[(this.stageTab || 0) as number]
    if (!stage) return []

    return stage.brackets.map((bracket, index) => ({
      text: bracket.name || '組別 #' + bracket.groupNumber,
      value: index
    }))
  }
}
